import * as XLSX from 'xlsx'

const AD_TYPE_LABEL = {
  reward: '激励视频',
  interstitial: '插屏',
  banner: 'Banner'
}

function formatRewardYuan(v) {
  return Number(((v ?? 0) / 1000).toFixed(4))
}

function pad2(n) {
  return String(n).padStart(2, '0')
}

function exportFileName(prefix = '广告记录') {
  const now = new Date()
  return `${prefix}_${now.getFullYear()}${pad2(now.getMonth() + 1)}${pad2(now.getDate())}_${pad2(now.getHours())}${pad2(now.getMinutes())}${pad2(now.getSeconds())}.xlsx`
}

/** 将广告记录导出为 Excel（浏览器下载） */
export function downloadAdRecordsExcel(records, options = {}) {
  const rows = (records || []).map((row) => ({
    分组: row.groupName || '未分组',
    设备: row.deviceId || '-',
    广告类型: AD_TYPE_LABEL[row.adType] || row.adType || '-',
    广告平台: row.adPlatform || '-',
    '收益(元)': formatRewardYuan(row.reward),
    发生时间: row.createdAt || '-'
  }))

  const sheet = XLSX.utils.json_to_sheet(rows.length ? rows : [{
    分组: '',
    设备: '',
    广告类型: '',
    广告平台: '',
    '收益(元)': '',
    发生时间: ''
  }])
  sheet['!cols'] = [
    { wch: 16 },
    { wch: 28 },
    { wch: 12 },
    { wch: 18 },
    { wch: 12 },
    { wch: 20 }
  ]

  const book = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(book, sheet, '广告记录')
  XLSX.writeFile(book, options.filename || exportFileName())
}
